import React from "react";
import {NavLink} from "react-router-dom";
import {colors} from "../../../../../shared/theme/colors";
import {ListItem, ListItemIcon, Typography} from "@mui/material";

const DrawerListItem = (props) => {
    return (
        <ListItem
            sx={{
                padding: 0,
                "& .MuiListItemIcon-root": {
                    color: "rgba(255, 255, 255, 0.85)",
                },
                "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                },
                "& > .active > .MuiListItemIcon-root": {
                    color: colors.tertiary.main,
                },
                "& > .active > h6": {
                    color: "#fff",
                },
                "& > .active": {
                    backgroundColor: colors.primary.main,
                    borderLeft: `4px solid ${colors.tertiary.main}`,
                },
            }}
        >
            <NavLink
                to={props.to}
                className={({ isActive }) => (isActive ? "active" : "")}
                style={{
                    width: "100%",
                    display: "inline-flex",
                    padding: "16px 8px",
                    textDecoration: "none",
                }}
            >
                <ListItemIcon>{props.icon}</ListItemIcon>
                <Typography
                    variant={props.fontStyle}
                    sx={{
                        color: "rgba(255, 255, 255, 0.85)",
                        alignSelf: "center",
                    }}
                >
                    {props.text}
                </Typography>
            </NavLink>
        </ListItem>
    )
}


export default DrawerListItem;
